"use client";

import { useSettingProductTileIterationInTreatment } from "@faire/retailer-visitor-shared/settings/useSettingProductTileIteration";
import { Column } from "@faire/web/slate/Layout/Column";

export const BrandInfoWrapper = ({
  children,
  isBatch10ProductTilesV4,
}: {
  children: React.ReactNode;
  isBatch10ProductTilesV4: boolean;
}) => {
  const showTileIterationChanges = useSettingProductTileIterationInTreatment();
  const tabletAndAboveGap =
    isBatch10ProductTilesV4 || showTileIterationChanges ? 2 : 4;
  return (
    <Column
      gap={{ mobileAndAbove: 2, tabletAndAbove: tabletAndAboveGap }}
      tabIndex={0}
    >
      {children}
    </Column>
  );
};
